import { useContext } from "react"
import { RoomContext } from "../utils/RoomContext"

export const useRoom = () => {
  const context = useContext(RoomContext)
  return context
}
